'use strict';

angular.module('mediacloudApp')
    .controller('ResetFinishController', function ($scope, $rootScope, $stateParams, Auth) {
    $scope.reset = false;
    $rootScope.hideHeaderAndFooter = true;
    $rootScope.lmsCSS = false;
    $scope.confirmPassword = false;
    Auth.validateToken({token: $stateParams.key, isReset: true }).then(function (result) {
        $scope.reset = result.reset;
        $scope.error = null;
        $scope.success = 'OK';
    }).catch(function () {
        $scope.success = null;
        $scope.error = 'ERROR';
    });
    var validate = function () {
        $('#userForm').validate({
            errorPlacement: function(error,element) {
              return true;
            },
            rules: {
                createPass: {
                    required: true,
                    passwordSuccess: true
                },
                confirmPass: {
                    required: true,
                    equalTo : "#createPass",
                }
            },
            messages: {
                createPass: {
                    required: "Please enter your password",
                },
                confirmPass: {
                    required: "Please confirm your password",
                    equalTo : "The passwords do not match"
                }
            }
        });
    }
    var validateCreateField = function(matched, prop) {
        if (!matched) {
         $('.' + prop).removeClass('success-bullet');
         $('.' + prop).addClass('error-bullet');
        }
        else {
         $('.' + prop).removeClass('error-bullet');
         $('.' + prop).addClass('success-bullet');
        }
    }
    $(document).ready(function() {
        $('#createPass').focus();
        $('[data-toggle="tooltip"]').tooltip({
            trigger: "hover",
            delay: {
               show: "1000",
               hide: "100"
            },
        });
        $.validator.addMethod("passwordSuccess",function(value,element){
          return $scope.passwordSuccess;
        });
        $.validator.addMethod("passwordMatch",function(value,element){
          return $scope.confirmPassword;
        });
        validate();
        $('#userForm input').focus(function () {
            validate();
        })
    });
    $('#reset').on('click', function () {
        if ($scope.passwordSuccess) {
            Auth.resetPasswordFinish({key: $stateParams.key, newPassword: $('#createPass').val()}).then(function (result) {
                $scope.reset = result.reset
                $scope.error = null;
                $scope.success = 'OK';
            }).catch(function () {
                $scope.success = null;
                $scope.error = 'ERROR';
            });
        }
    });

    var createPassChange = function (el) {
        var pass = $(el).val();
        var lowercaseMatch = pass.toString().trim().toUpperCase() != pass;
        var uppercaseMatch = pass != pass.toLowerCase();
        var lengthMatch = pass.length >= 12;
        var specialCharsDigitMatch = (/[$&+,:;=?[\]@#|{}'<>.^*()%!-/]/.test(pass) || /\d/.test(pass)) && pass.length > 0 ;
        $scope.passwordSuccess = lowercaseMatch && uppercaseMatch && lengthMatch && specialCharsDigitMatch;
        var className = $(el).next().attr("class");
        if (pass.length > 0) {
            if (className.includes(' seen')) {
                $(el).next().attr("class", "showHide seen");
            }
            else {
                $(el).next().attr("class", "showHide unseen");
            }
        }
        else {
            if (className.includes(' seen')) {
                $(el).next().attr("class", "showHide seen hide");
            }
            else {
                $(el).next().attr("class", "showHide unseen hide");
            }
        }
        var confirmPass = $('#confirmPass').val();
        $scope.confirmPassword = pass.trim() === confirmPass.trim();
        if ($scope.passwordSuccess && $scope.confirmPassword) {
            $('#reset').removeAttr('disabled');
        }
        else {
            $('#reset').attr('disabled', 'true');
        }
        validateCreateField(lowercaseMatch, 'lowercase');
        validateCreateField(uppercaseMatch, 'uppercase');
        validateCreateField(lengthMatch, 'length');
        validateCreateField(specialCharsDigitMatch, 'special');
    }

    var confirmPassChange = function (el) {
        var createPass = $('#createPass').val();
        var confirmPass = $(el).val();
        $scope.confirmPassword = createPass.trim() === confirmPass.trim();
        var className = $(el).next().attr("class");

        if (confirmPass.length > 0) {
            if (className.includes(' seen')) {
                $(el).next().attr("class", "showHide seen");
            }
            else {
                $(el).next().attr("class", "showHide unseen");
            }
        }
        else {
            if (className.includes(' seen')) {
                $(el).next().attr("class", "showHide seen hide");
            }
            else {
                $(el).next().attr("class", "showHide unseen hide");
            }
        }

        if ($scope.passwordSuccess && $scope.confirmPassword) {
            $('#reset').removeAttr('disabled');
        }
        else {
            $('#reset').attr('disabled', 'true');
        }
        if ($scope.confirmPassword) {
            $('#mainError').css('display', 'none');
        }
        else {
            $('#mainError').css('display', 'block');
        }
    }

    $('#createPass').change(function (k,v) {
        createPassChange(this);
    });

    $('#createPass').keyup(function (k,v) {
        createPassChange(this);
    });

    $('#confirmPass').change(function (k,v) {
        confirmPassChange(this);
    });

    $('#confirmPass').keyup(function (k,v) {
        confirmPassChange(this);
    });

    $scope.togglePassword = function (event) {
        var currentElement = $(event.currentTarget);
        var input = currentElement.prev();

        // set type and icon
        var type = input.attr('type') === 'password' ? 'text' : 'password';
        input.removeAttr('type');
        input.attr('type', type);

        var src = currentElement.attr('src');

        if (currentElement.attr('class').includes(' unseen')) {
            currentElement.html('');
            currentElement.html("\n<g fill=\"none\" fill-rule=\"evenodd\">\n <g class=\"password-icon\" fill=\"#6E6E6E\">\n<g>\n<path d=\"M8.5 8.643c-1.707 0-3.09-1.407-3.09-3.143 0-1.736 1.383-3.143 3.09-3.143 1.707 0 3.09 1.407 3.09 3.143 0 1.736-1.383 3.143-3.09 3.143M8.5 0C3.592 0 0 5.5 0 5.5S3.592 11 8.5 11c4.908 0 8.5-5.5 8.5-5.5S13.408 0 8.5 0\" transform=\"translate(-868 -497) translate(868 497)\"></path>\n<path d=\"M8.5 3C9.88 3 11 4.12 11 5.5S9.88 8 8.5 8 6 6.88 6 5.5 7.12 3 8.5 3\" transform=\"translate(-868 -497) translate(868 497)\"></path>\n</g>\n</g>\n</g>\n");
            currentElement.attr("class", "showHide seen");
            currentElement.attr('data-original-title', 'Hide Password');
        }

        else {
            currentElement.html('');
            currentElement.html("\n<defs>\n<path id=\"tvukzjn4la\" d=\"M0.635 0.088L17 0.088 17 16 0.635 16z\"></path>\n<path id=\"9oxja6ztwc\" d=\"M0 0.428L10.737 0.428 10.737 8.832 0 8.832z\"></path>\n                                        </defs>\n                                        <g fill=\"none\" fill-rule=\"evenodd\">\n                                            <g>\n                                                <g>\n                                                    <g transform=\"translate(-868 -405) translate(868 405)\">\n                                                        <mask id=\"dnjv9k1ggb\" fill=\"#fff\">\n                                                            <use xlink:href=\"#tvukzjn4la\"></use>\n                                                        </mask>\n                                                        <path class=\"password-icon\" fill=\"#6E6E6E\" d=\"M8.5 10.684c-.409 0-.797-.081-1.154-.224l4.017-3.96c.144.35.228.733.228 1.136 0 1.684-1.384 3.048-3.091 3.048m5.021-6.312l3.253-3.206L15.68.088.635 14.922 1.728 16l3.993-3.938c.862.32 1.791.525 2.779.525 4.908 0 8.5-4.952 8.5-4.952s-1.334-1.828-3.479-3.264\" mask=\"url(#dnjv9k1ggb)\"></path>\n                                                    </g>\n                                                    <g transform=\"translate(-868 -405) translate(868 405) translate(0 2)\">\n                                                        <mask id=\"g5kf5t6bod\" fill=\"#fff\">\n                                                            <use xlink:href=\"#9oxja6ztwc\"></use>\n                                                        </mask>\n                                                        <path class=\"password-icon\" fill=\"#6E6E6E\" d=\"M2.974 8.832l2.562-2.67c-.018-.137-.036-.274-.036-.416 0-1.808 1.407-3.272 3.143-3.272.136 0 .268.018.4.036L10.737.748c-.665-.197-1.363-.32-2.094-.32C3.652.428 0 5.746 0 5.746s1.124 1.63 2.974 3.086\" mask=\"url(#g5kf5t6bod)\"></path>\n                                                    </g>\n                                                </g>\n                                            </g>\n                                        </g>                                    ");
            currentElement.attr("class", "showHide unseen");
            currentElement.attr('data-original-title', 'Show Password');
        }
    }
});

